export default "__VITE_ASSET__BJ17OF26__"